var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBookingcomCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1228_2296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.27813 0 0 6.27812 0 14C0 21.7219 6.27813 28 14 28C21.7219 28 28 21.7219 28 14C28 6.27812 21.7219 0 14 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1228_2296)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9327 4.91248V23.0885C27.9327 25.8014 25.7351 28 23.0234 28H0L0.00203204 23.0885V20.5647L0 4.91248C0 2.2006 2.19861 0 4.91029 0H23.0224C25.7331 0 27.9327 2.2006 27.9327 4.91248ZM20.2808 19.2179C20.2808 20.1205 21.0082 20.8534 21.9063 20.8534C22.8065 20.8534 23.538 20.1205 23.538 19.2179C23.538 18.3153 22.8065 17.5845 21.9063 17.5845C21.0082 17.5845 20.2808 18.3153 20.2808 19.2179ZM17.3659 13.7698L16.9534 13.538L17.3141 13.23C17.7316 12.8712 18.4327 12.0621 18.4327 10.6645C18.4327 8.52695 16.7736 7.14764 14.2092 7.14764H10.9489C10.1889 7.1761 9.58032 7.7941 9.5722 8.55948V20.6918H10.9153C10.9184 20.6938 10.9194 20.6918 10.9214 20.6938L14.2681 20.6918C17.12 20.6918 18.961 19.1386 18.961 16.7337C18.961 15.4398 18.3646 14.3329 17.3659 13.7698ZM12.1772 12.6232V10.3322C12.1772 9.70501 12.4424 9.40618 13.0266 9.36857H14.1919C15.1927 9.36857 15.7901 9.96624 15.7901 10.9674C15.7901 11.7308 15.3796 12.6232 14.2285 12.6232H12.1772ZM14.4551 18.3997L12.1772 18.3987V15.6726C12.1772 15.0912 12.4038 14.7883 12.9016 14.7191H14.4551C15.5655 14.7191 16.2808 15.4195 16.2818 16.5498C16.2808 17.7105 15.5818 18.3997 14.4551 18.3997Z",
    fill: "#253C69"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookingcomCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookingcom-circle.3ab6faef.svg";
export { ForwardRef as ReactComponent };